import {IServiceFactory} from "../../../../service-factory.interface";
import {SpecialAssistanceSsrBase} from "../special-assistance-ssr-base";

//Deaf customer
export default class DeafSsrType extends SpecialAssistanceSsrBase {
    constructor(services: IServiceFactory) {
        super('DEAF', services);
    }
}
